var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamD(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.6 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.25,
    cy: 2.5,
    rx: 2.25,
    ry: 2.5,
    transform: "translate(2.15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,107.2v1.6h8.8v-1.6a3.2,3.2,0,0,0-3.2-3.2h-2.4A3.2,3.2,0,0,0,152,107.2Z",
    transform: "translate(-152 -98.8)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 13.846)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1.6 0.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,379.2a3.2,3.2,0,0,0-3.2-3.2H11.2A3.2,3.2,0,0,0,8,379.2v1.6h8.8Z",
    transform: "translate(-8 -371.046)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.8 13.846)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(2.2 0.154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.6,376h-2.4a3.2,3.2,0,0,0-3.2,3.2v1.6h8.8v-1.6A3.2,3.2,0,0,0,301.6,376Z",
    transform: "translate(-296 -371.046)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144,8.4V10a.4.4,0,0,0,.4.4h8.8a.4.4,0,0,0,.4-.4V8.4a3.6,3.6,0,0,0-2.918-3.533,2.8,2.8,0,1,0-3.765,0A3.6,3.6,0,0,0,144,8.4Zm2.8-5.6a2,2,0,1,1,2,2A2,2,0,0,1,146.8,2.8Zm.8,2.8H150a2.8,2.8,0,0,1,2.8,2.8V9.6h-8V8.4A2.8,2.8,0,0,1,147.6,5.6Z",
    transform: "translate(-136.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.4,282.4H9.2a.4.4,0,0,0,.4-.4v-1.6a3.6,3.6,0,0,0-2.918-3.533,2.8,2.8,0,1,0-3.765,0A3.6,3.6,0,0,0,0,280.4V282A.4.4,0,0,0,.4,282.4Zm2.4-7.6a2,2,0,1,1,2,2A2,2,0,0,1,2.8,274.8Zm-2,5.6a2.8,2.8,0,0,1,2.8-2.8H6a2.8,2.8,0,0,1,2.8,2.8v1.2H.8Z",
    transform: "translate(0 -258.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M294.682,276.867a2.8,2.8,0,1,0-3.765,0A3.6,3.6,0,0,0,288,280.4V282a.4.4,0,0,0,.4.4h8.8a.4.4,0,0,0,.4-.4v-1.6A3.6,3.6,0,0,0,294.682,276.867ZM290.8,274.8a2,2,0,1,1,2,2A2,2,0,0,1,290.8,274.8Zm6,6.8h-8v-1.2a2.8,2.8,0,0,1,2.8-2.8H294a2.8,2.8,0,0,1,2.8,2.8Z",
    transform: "translate(-273.6 -258.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.729,82.544c-.219.167-.434.345-.641.531l.535.6c.19-.171.389-.336.591-.49Z",
    transform: "translate(-96.034 -78.417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.168,255.775c.011.276.033.555.066.829l.794-.1c-.03-.253-.051-.511-.061-.765Z",
    transform: "translate(-30.56 -242.957)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.512,64.99l.434.673c.216-.14.438-.27.661-.389l-.377-.706C127.988,64.7,127.746,64.839,127.512,64.99Z",
    transform: "translate(-121.136 -61.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.168,224l.8.031c.01-.256.03-.513.06-.766l-.794-.094C32.2,223.449,32.178,223.728,32.168,224Z",
    transform: "translate(-30.56 -212.017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.336,105.327l-.58-.551c-.192.2-.376.412-.548.625l.622.5C78.989,105.707,79.16,105.513,79.336,105.327Z",
    transform: "translate(-74.298 -99.537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.088,191.392l.784.158c.05-.25.111-.5.182-.746l-.769-.22C36.209,190.848,36.143,191.121,36.088,191.392Z",
    transform: "translate(-34.284 -181.055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.256,160.207l.749.281c.09-.239.19-.477.3-.707l-.724-.342C45.462,159.69,45.354,159.948,45.256,160.207Z",
    transform: "translate(-42.993 -151.468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.424,131.3l.694.4c.126-.221.264-.44.408-.65l-.66-.452C59.71,130.828,59.561,131.065,59.424,131.3Z",
    transform: "translate(-56.453 -124.07)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,436.16c-.248.05-.5.092-.758.123l.1.794c.276-.034.552-.078.821-.133Z",
    transform: "translate(-250.078 -414.352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.784,440.639l-.032-.8c-.256.01-.514.011-.768,0l-.032.8c.133.006.268.008.4.008S232.642,440.645,232.784,440.639Z",
    transform: "translate(-220.354 -417.848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.094,436.256l-.158.784c.269.054.546.1.822.13l.093-.794C199.6,436.346,199.342,436.306,199.094,436.256Z",
    transform: "translate(-188.989 -414.443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.72,145.134c.127.221.246.45.355.681l.724-.342c-.118-.25-.247-.5-.384-.737Z",
    transform: "translate(-386.384 -137.499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.784,175.1c.09.238.17.484.241.728l.769-.22c-.076-.266-.164-.531-.261-.79Z",
    transform: "translate(-398.795 -166.075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.384,117.823c.16.2.314.4.459.616l.66-.452c-.157-.228-.324-.453-.5-.667Z",
    transform: "translate(-369.915 -111.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.224,206.934c.05.25.091.506.121.758l.794-.094c-.032-.274-.076-.55-.131-.822Z",
    transform: "translate(-406.813 -196.437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.256,93.819c.19.171.375.351.55.535l.581-.55c-.19-.2-.39-.4-.6-.58Z",
    transform: "translate(-349.843 -88.563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.144,57.328l-.32.733c.233.1.465.215.69.336l.378-.7C317.649,57.56,317.4,57.438,317.144,57.328Z",
    transform: "translate(-300.983 -54.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.986,73.518c-.22-.168-.449-.329-.681-.478l-.433.673c.214.138.425.286.628.442Z",
    transform: "translate(-326.678 -69.388)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.647,240.607q.008-.209.008-.42c0-.137,0-.274-.008-.41l-.8.031c.005.126.008.253.008.38s0,.259-.008.388Z",
    transform: "translate(-410.256 -227.787)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamD);
export default __webpack_public_path__ + "static/media/team_d.f3a17d200604d46c2202f620f2303a9a.svg";
export { ForwardRef as ReactComponent };